import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./App.js";
import { initServiceWorker } from "./pwa/registerSW.js";
import { UpdatePrompt } from "./pwa/UpdatePrompt.js";
import "./styles.css";

const container = document.getElementById("root");
if (!container) throw new Error("#root not found");

// Đăng ký SW ngoài React: nó không phụ thuộc render, và nếu để trong một effect thì StrictMode
// (mount hai lần trong dev) sẽ đăng ký/hủy vòng vòng.
initServiceWorker();

createRoot(container).render(
  <StrictMode>
    <App />
    <UpdatePrompt />
  </StrictMode>,
);
